import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  chatGroupId: string
  fileName: string
  filePath: string
}

export class SendFileMessageWriteRequest extends WriteRequest<void> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    const { fileName, filePath } = this.params
    return this.apiClient.post(this.makeEndpoint(), { fileName, filePath })
  }

  private makeEndpoint(): string {
    return `/matching/user/chat_group/${this.params.chatGroupId}/file/create`
  }
}
